import React, { FormEvent, ReactElement } from 'react';
import {
  Button,
  Col, Heading, LoaderButton, Row, Text,
} from 'idsk-react-components';
import { v4 as uuidv4 } from 'uuid';
import { BackButton } from 'slovlex-idsk-react-components';
import PouzitiePredpis from '../../../../../model/PouzitiePredpis';
import PouzitieVPredpisochItem from './PouzitieVPredpisochItem';
import addIcon from '../../../../../../assets/images/icon-plus-dark.svg';

interface Props {
  pouzitiePredpisList: Array<PouzitiePredpis>;
  setPouzitiePredpisList: (pouzitiePredpisList: Array<PouzitiePredpis>) => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  clearAllFieldErrorMessages?: () => void;
  getFieldErrorMessage: (fieldName: string) => string | undefined;
  loading: boolean;
}

const PouzitieVPredpisochUpdateForm = ({
  pouzitiePredpisList,
  setPouzitiePredpisList,
  onSubmit,
  clearAllFieldErrorMessages,
  getFieldErrorMessage,
  loading,
}: Props): ReactElement => {
  const addPouzitiePredpis = async (): Promise<void> => {
    setPouzitiePredpisList([...pouzitiePredpisList, {
      key: uuidv4(), url: '', uuid: '', popis: '',
    }]);
  };

  return (
    <>
      <Heading size="l">Použitie v iných právnych predpisoch</Heading>
      <form onSubmit={onSubmit} className="admin-termin-create-form">
        {pouzitiePredpisList?.map((pouzitiePredpis, index) => (
          <PouzitieVPredpisochItem
            key={pouzitiePredpis.key || pouzitiePredpis.uuid}
            itemList={pouzitiePredpisList}
            setItemList={setPouzitiePredpisList}
            itemId={index}
            clearAllFieldErrorMessages={clearAllFieldErrorMessages}
            getFieldErrorMessage={getFieldErrorMessage}
          >
            {index === pouzitiePredpisList.length - 1 && (
              <Button
                size="large"
                onClick={addPouzitiePredpis}
                iconBefore={addIcon}
                buttonStyle="third"
              >Pridať predpis
              </Button>
            )}
          </PouzitieVPredpisochItem>
        ))}
        {pouzitiePredpisList.length === 0 && (
          <>
            <Text className="pouzitie-predpis-item">
              Prázdny zoznam predpisov.
            </Text>
            <Button
              size="large"
              onClick={addPouzitiePredpis}
              iconBefore={addIcon}
              buttonStyle="third"
            >Pridať predpis
            </Button>
          </>
        )}
        <Row className="admin-termin-create__actions">
          <Col width="one-half">
            <LoaderButton
              className="admin-termin-create__create-button"
              loading={loading}
              type="submit"
              size="large"
            >
              Uložiť zmeny
            </LoaderButton>
            <BackButton disabled={loading} />
          </Col>
        </Row>
      </form>
    </>
  );
};

export default PouzitieVPredpisochUpdateForm;
